/**
 * @Description Fasat Grid Coulmn Input Text Filter
 * @FileName ColumnFilter.js
 * @Author ABHISEK KUNDU-kundabh
 * @CreatedOn 05 February, 2021 10:52:45
 * @IssueID -323
 */
import React, { useCallback, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import PropTypes from 'prop-types';
import { FasatIcon, FasatTextInput } from '../../../../../components';

export const asyncDebounceSetData = (setValue, setFilter, changeValue) => {
  setValue(changeValue.target.value);
  setFilter(changeValue.target.value || undefined);
};

function TextFilter({ column }) {
  const { filterValue, setFilter } = column;
  const [value, setValue] = useState(filterValue);
  const debouncingTimeout = 1000;
  /**
   * debouncing method for column onChange filter
   */
  const onChange = useAsyncDebounce((changeValue) => {
    asyncDebounceSetData(setValue, setFilter, changeValue);
  }, debouncingTimeout);
  const handleOnChange = useCallback((val) => {
    onChange(val);
  }, [onChange]);
  return (
    <FasatTextInput
      value={value || ''}
      onChange={handleOnChange}
      placeholder="Search"
      icon={<FasatIcon aria-hidden="true" color="none" fill="none" manulifeName="search" width="20px" height="20px" style={{ transform: 'rotate(-90deg)' }} />}
    />
  );
}

TextFilter.propTypes = {
  column: PropTypes.arrayOf(PropTypes.shape({
    filterValue: PropTypes.string,
    setFilter: PropTypes.func,
  })).isRequired,
};

export default TextFilter;
